<!--
 * @Dscription: 
 * @version: 
 * @Author: 
 * @Date: 2019-09-29 10:26:58
 * @LastEditTime: 2019-10-14 10:26:33
 -->
<template>
  <!-- 员工管理 -->
  <div class="fillcontain">
    <div class="navCalss" style="margin-top: 20px">| 货物价格</div>
    <div class="wrl-flexRight">
      <!-- 表单查找内容 -->
      <el-button type="primary" @click="openAdd()">新增货物类型</el-button>
    </div>
    <div class="table_container">
      <!-- 遍历所有员工信息 -->
      <el-table
        :data="tableData"
        border
        highlight-current-row
        style="width: 100%"
        size="medium"
      >
        <!-- <el-table-column
          prop="adminId"
          label="序号"
          align="center"
          min-width="100px"
        >
          <template slot-scope="scope">
            <span v-text="getIndex(scope.$index)"> </span>
          </template>
        </el-table-column> -->
           <el-table-column label="货物类型" align="center" min-width="100px">
          <template slot-scope="scope">
           <span>{{goodTypeName(scope.row.goodType)}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="goodName" label="货物名称" align="center">
        </el-table-column>
        <el-table-column label="价格系数" align="center" min-width="100px">
          <template slot-scope="scope">
            {{ scope.row.price }}
          </template>
        </el-table-column>

        <el-table-column
          prop="mobile"
          label="是否计算首重"
          min-width="100px"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.firstWeight"> 是 </span>
            <span v-else> 否 </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="operatorTime"
          label="操作时间"
          min-width="150px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          min-width="180px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="operation"
          align="center"
          label="操作"
          fixed="right"
          width="200px"
        >
          <template slot-scope="scope">
             <el-button type="text" @click="onEdit(scope.row)">编辑</el-button>
             <el-button type="text" @click="onDel(scope.row)"><span style="color: red">移除</span></el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <el-row style="margin-top: 20px">
        <el-col :span="24">
          <div class="pagination">
            <el-pagination
              :page-sizes="paginations.page_sizes"
              :page-size="paginations.page_size"
              :layout="paginations.layout"
              :total="paginations.total"
              :current-page="paginations.page_index"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            >
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 弹出微信二维码 -->
    <!--  -->

    <!-- 弹出修改对话框 -->
    <el-dialog
      :title="dialog.title"
      :visible.sync="dialog.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="500px"
    >
      <div class="form">
        <el-form
          :model="priceGoods.netBarForm"
          :rules="priceGoods.form_rules"
          ref="netBar"
          :label-width="priceGoods.formLabelWidth"
          style="margin: 20px; width: auto"
          label-position="right"
        >
          <!-- 客户基础信息 -->
          <el-form-item label="货物类型:" prop="goodType">
            <el-select
                  v-model="priceGoods.netBarForm.goodType"
                  placeholder="请选择货物类型"
                  style="width: 208px"
                  filterable
                >
                  <el-option
                    v-for="item in priceGoods.goodTypeSelect"
                    :key="item.goodType"
                    :label="item.goodName"
                    :value="item.goodType"
                  >
                  </el-option>
                </el-select>
          </el-form-item>
          <el-form-item prop="goodName" label="类型名称:">
            <el-input
              v-model="priceGoods.netBarForm.goodName"
              placeholder="请输入类型名称"
              style="width: 308px"
            ></el-input>
          </el-form-item>
          <el-form-item label="价格系数:" prop="price">
            <el-input
              v-model="priceGoods.netBarForm.price"
              placeholder="请输入价格系数"
              style="width: 308px"
            ></el-input>
          </el-form-item>
          <el-form-item label="计算首重:" prop="firstWeight">
            <el-radio-group v-model="priceGoods.netBarForm.firstWeight">
              <el-radio :label="2">是</el-radio>
              <el-radio :label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注:">
            <el-input
              v-model="priceGoods.netBarForm.remark"
              placeholder="请输入备注(选填)"
              style="width: 308px"
            ></el-input>
          </el-form-item>
        </el-form>

        <div style="margin: 0 150px">
          <el-button type="primary" @click="onsumbit()" v-if="showOnsub"
            >提交</el-button
          >
          <el-button
            @click="dialog.show = false"
            :class="showOnsub ? '' : 'margiLeft'"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- //确认移除 -->
    <el-dialog
      :visible.sync="dialog.showB"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="340px"
      center
    >
      <div style="text-align: center">
        <span>您确定删除该货物类型信息嘛？</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="deleteGoods(galObj)">移除</el-button>
        <el-button @click="dialog.showB = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as mUtils from "utils/mUtils";
import * as priceGoods from "@/api/priceGoods.js";
import { axios } from "utils/";

export default {
  data() {
    let dataValidate = (rule, value, callback) => {
      if (value === "") {
        let text;
        if (rule.field == "goodName") {
          text = "类型名称";
        } else if (rule.field == "price") {
          text = "价格系数";
        } else if (rule.field == "firstWeight") {
          text = "计算首重";
        }else if (rule.field == "goodType") {
          text = "货物类型";
        }
        callback(new Error(text + "不能为空~"));
      } else {
        if (rule.field == "price") {
          let numReg = /^\d+(\.\d+)?$/;

          if (!numReg.test(value)) {
            callback(new Error("请输入数字"));
            return;
          } else {
            if (value < 0) {
              callback(new Error("请输入大于等于0的值"));

              return;
            }
          }
          return callback();
        }
      }
    };

    return {
      galObj: {},
      showOnsub: true,
      adminId: "",

      indexB: "",
      statusA: "",
      searchData: {
        keyWord: "",
        keyWord2: "",
      },
      indexA: "",
      rowDmind: "",
      dadBool: false,
      options: [],
      tableData: [], //表格信息
      //创建管理员dialog
      dialog: {
        width: "300px",
        show: false,
        showC: false,
        title: "新增货物类型",
        formLabelWidth: "120px",
        showB: false,
        showC: false,
      },
      priceGoods: {
        width: "300px",
        show: false,
        title: "",
        formLabelWidth: "120px",
        appendOrUpdate: 1, //1/2 添加/更改
        goodTypeSelect:[
            {
              goodType:1,
              goodName:"海运"
            }, {
              goodType:2,
              goodName:"海运大件"
            }, {
              goodType:3,
              goodName:"空运"
            }
        ],
        netBarForm: {
          goodName: "",
          price: "",
          firstWeight: 2,
          remark: "",
          goodType:1,
        },
        //信息修改规则
        form_rules: {
           goodType: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          goodName: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          price: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],

          firstWeight: [
            {
              required: true,
              validator: dataValidate,
              trigger: "change",
            },
          ],
        },
      },
      search_data: {
        //搜索内容
        realName: "",
        mobile: "",
      },
      updateOrAdd: 0, //dialog submit是创建1还是更新数据0 (ps:因为创建和更新共用一个dialog)
      paginations: {
        //分页数据
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        page_sizes: [5, 10, 15, 20], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
    };
  },
  created() {
    let that = this;
    this.getPriceGoodsList();
  },
  methods: {
    goodTypeName(goodType){
      let str = "";
      switch(goodType){
        case 1:
          str = "海运";
          break;
        case 2:
          str = "海运大件";
          break;
        case 3:
          str = "空运";
          break;    
      }
      return str;
    },
    //移除
    deleteGoods(val) {
      let that = this;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      let data = {};
      data = {
        goodId: val.goodId || "",
        goodName: val.goodName || "",
        price: val.price || "",
        firstWeight: Number(val.firstWeight),
        reamrk: val.remark || "",
      };
      priceGoods.del(data).then(function (res) {
        if (res.data.code != 0) {
          let msg;
          msg = "删除失败!";
          that.$message.error(msg);
          loading.close();
          return;
        } else {
          let msg;
          msg = "删除成功 !";
          that.$message({
            message: msg,
            type: "success",
          });
          that.dialog.showB = false;

          that.getPriceGoodsList();
          loading.close();
        }
      });
    },
    //移除
    onDel(val) {
      this.galObj = val;
      this.dialog.showB = true;
    },
    //编辑
    onEdit(val) {
      let that = this;
      that.priceGoods.netBarForm.goodId = val.goodId;
      that.priceGoods.netBarForm.goodType = val.goodType;
      that.priceGoods.netBarForm.goodName = val.goodName;
      that.priceGoods.netBarForm.price = val.price;
      that.priceGoods.netBarForm.firstWeight = val.firstWeight + 1;
      that.priceGoods.netBarForm.remark = val.remark || "";
      this.dialog.show = true;
    },
    //提交表单
    onsumbit() {
      let that = this;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      let data = {};

      let validd;
      if (
        that.priceGoods.netBarForm.goodName &&
        that.priceGoods.netBarForm.price &&
        that.priceGoods.netBarForm.firstWeight
      ) {
        validd = true;
      } else {
        validd = false;
      }
      //  console.log()
      this.$refs.netBar.validate((valid) => {
        validd = valid;

        return true;
      });

      if (validd) {
        data = {
          goodId: that.priceGoods.netBarForm.goodId || "",
          goodName: that.priceGoods.netBarForm.goodName || "",
          price: that.priceGoods.netBarForm.price || "",
          firstWeight: Number(that.priceGoods.netBarForm.firstWeight) - 1,
          reamrk: that.priceGoods.netBarForm.remark || "",
          goodType:that.priceGoods.netBarForm.goodType
        };
        priceGoods.add(data).then(function (res) {
          if (res.data.code != 0) {
            let msg;
            if (that.priceGoods.netBarForm.goodId) {
              msg = res.data.msg;
            } else {
              msg = "保存失败!";
            }
            that.$message.error(msg);
            loading.close();
            return;
          } else {
            let msg;
            msg = "保存成功 !";
            that.$message({
              message: msg,
              type: "success",
            });
            that.dialog.show = false;
            that.getPriceGoodsList();
            loading.close();
          }
        });
      } else {
        that.$message.error("表单输入错误 !");
        loading.close();
        return false;
      }
    },
    /**
    
     * @description 打开弹框
     
     */
    openAdd() {
      let that = this;
      that.priceGoods.netBarForm.goodId = "";
      that.priceGoods.netBarForm.goodName = "";
      that.priceGoods.netBarForm.price = "";
      that.priceGoods.netBarForm.firstWeight = 2;
      that.priceGoods.netBarForm.remark = "";
      this.dialog.show = true;
    },
    /**
     * @name
     * @description 获取类型列表
     * @main_method post(url,data)
     * @interface getPriceGoodsList
     */
    getPriceGoodsList(dataA) {
      let that = this;

      let data = {
        pageIndex: this.paginations.page_index,
        pageSize: this.paginations.page_size,
      };

      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      priceGoods.goodList(data).then(function (res) {
        loading.close();

        if (res.data.code != 0) {
          that.$message.error("获取列表失败");
          return;
        } else {
          res.data.data.list.forEach(function (val, i) {
            val.operatorTime = mUtils
              .formatDate(new Date(val.operatorTime))
              .substring(0, 16);
          });
          that.tableData = res.data.data.list;

          that.paginations.total = res.data.data.pageCount;
        }
      });
      loading.close();
    },
    //获取表格序号
    getIndex($index) {
      //表格序号
      return (
        (this.paginations.page_index - 1) * this.paginations.page_size +
        $index +
        1
      );
    },

    // 每页多少条切换
    handleSizeChange(page_size) {
      let that = this;
      that.paginations.page_size = page_size;
      that.getPriceGoodsList();
    },
    // 上下分页
    handleCurrentChange(page) {
      let that = this;
      that.paginations.page_index = page;
      that.getPriceGoodsList();
    },
  },
};
</script>

<style lang="less" scoped>
.wrl-flexRight {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
.fillcontain {
  // margin-left: 30px;
  margin: 40px 40px 80px 40px;
}

.search-form {
  // width: 100%;
  // min-width: 750px;
  margin-top: 20px;
  margin-bottom: 10px;

  .el-form-item {
    margin-bottom: 10px !important;

    .el-date-editor {
      width: 200px;
    }
  }
}

.el-dialog--small {
  width: 600px !important;
  display: none;
  display: block;
}

.pagination {
  text-align: center;
  margin-top: 30px;
}
.navCalss {
  font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
    sans-serif;
  font-weight: 650;
  font-size: 18px;
}
.margiLeft {
  margin-left: 5vw;
  background-color: #409eff;
  color: white;
}
</style>


// WEBPACK FOOTER //
// priceGoods.vue?626aaece